import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'

export const appConverter = { to: v => v, from: v => isNull(v) || isUndefined(v) ? '' : v }
